/*
 * 增则匹配
 * exprEmail 匹配邮箱
 */
export function exprEmail( value ){
    let expr = /^[a-zA-Z0-9]([a-zA-Z0-9]|_+[a-zA-Z0-9]|[a-zA-Z0-9]*\.[a-zA-Z0-9])+@\w+\.[a-zA-Z]{1,4}\.{0,1}[a-zA-Z]{0,4}$/
    if( value ){
        if( expr.test(value) ){
            return value
        }else{
            return false
        }
    }else{
        return false
    }
}

/**
 * exprInt 匹配数字
 */
export function exprInt( value ){
    let expr = /^[0-9]*$/
    if( value ){
        if( expr.test(value) ){
            return value
        }else{
            return false
        }
    }else{
        return false
    }
}

// Array => Set
export function arrayChangeSet( set ){
    return Array.from( set )
}

// object => array
export function objectChangeArray( object ){
    let rel = [];
    Object.keys( object ).map(( key ) => { rel[key] = object[ key ] });
    return rel;
}

// 并集
export function UnionSet( a, b ){
    let _unionSet = new Set([...(new Set(a)), ...(new Set(b))]);
    return objectChangeArray( arrayChangeSet( _unionSet ) )
}

// 交集
export function IntersectionSet( a, b ){
    let _intersectionSet = new Set([...(new Set(a))].filter(x => (new Set(b)).has(x)));
    return arrayChangeSet( _intersectionSet )
}

// 差集
export function DifferenceABSet( a, b ){
    let _differenceABSet = new Set([...(new Set(a))].filter(x => !(new Set(b)).has(x)));
    return objectChangeArray( arrayChangeSet( _differenceABSet ) )
}




// WEBPACK FOOTER //
// ./common/lib/ToolsExpr.js